import { useQSet } from '@exam-management/common/qset-provider';
import { QSetQuestionDetails } from '@exam-management/qset-question-details';
import { Flex, InfiniteScroll, Loading, Paper } from '@shared/components';
import { useEffect } from 'react';

import {
  useGetInfiniteQSetQuestionSnapshotDetailsList,
  useGetPaginatedQSetQuestionsSnapshotDetailsList,
  useQSetQuestionListSearchParams,
} from '../../hooks';

export default function QSetQuestionWithQuestionSnapshotList() {
  const { qSet } = useQSet();
  const [{ page, pageSize }, { getPageSizeAsNumber }] = useQSetQuestionListSearchParams();
  const pageSizeAsNumber = getPageSizeAsNumber(pageSize);
  const isInfiniteMode = pageSize === 'All';

  const {
    data: infiniteQSetQuestionsData,
    loading: isInfiniteQSetQuestionsLoading,
    fetchMoreLoading: isFetchingMoreInfiniteQSetQuestions,
    refetch: refetchInfiniteQSetQuestions,
    fetchMore: fetchMoreInfiniteQSetQuestions,
    hasMore,
  } = useGetInfiniteQSetQuestionSnapshotDetailsList({
    qSetId: qSet.id,
    pageSize: pageSizeAsNumber,
  });

  const {
    data: paginatedQSetQuestionsData,
    loading: isPaginatedQSetQuestionsLoading,
    refetch: refetchPaginatedQSetQuestions,
  } = useGetPaginatedQSetQuestionsSnapshotDetailsList({
    page,
    pageSize: pageSizeAsNumber,
    qSetId: qSet.id,
  });

  useEffect(() => {
    if (isInfiniteMode) {
      refetchInfiniteQSetQuestions();
    } else {
      refetchPaginatedQSetQuestions();
    }
  }, [pageSize]);

  const qSetQuestions = isInfiniteMode ? infiniteQSetQuestionsData : paginatedQSetQuestionsData;
  const isLoading = isInfiniteQSetQuestionsLoading || isPaginatedQSetQuestionsLoading;

  if (isLoading) {
    return <Loading sx={{ height: '100%' }} />;
  }

  const content = (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
      {qSetQuestions.map((qSetQuestion) => {
        const { id, questionSnapshot, order } = qSetQuestion;

        return (
          <Paper key={id}>
            <QSetQuestionDetails question={questionSnapshot} order={order} />
          </Paper>
        );
      })}
    </Flex>
  );

  return isInfiniteMode ? (
    <InfiniteScroll
      hasMore={hasMore}
      handleFetch={fetchMoreInfiniteQSetQuestions}
      loading={isFetchingMoreInfiniteQSetQuestions}
      loader={<Loading />}
      scrollThreshold={0.7}
      scrollableTarget='frame-content'
    >
      {content}
    </InfiniteScroll>
  ) : (
    content
  );
}
